import styled from "@emotion/styled";

export const ResponsiveEChartsRendererStyled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;
